import { useMemo } from 'react'
import { getTourTags, LuxPlusLabelTagOptions } from 'lib/tours/tourUtils'

function useTourTags(
  tour: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary,
  luxPlusLabels: LuxPlusLabelTagOptions = 'all',
  departureId?: string,
) {
  return useMemo(() => getTourTags(
    tour,
    false,
    luxPlusLabels,
    departureId,
  ), [tour, luxPlusLabels, departureId])
}

export default useTourTags
